import { OfferListingStatus } from '@steelbuy/ts-shared';
import enLiterals from './literals-en';

const literals = structuredClone(enLiterals);

literals.addressForm.postcode = 'ZIP code';
literals.listingDraft.attributeCertificate = 'MTR (Mill Test Report)';
literals.listingTeaserOfferBadge.status[OfferListingStatus.CANCELLED] = 'Canceled';
literals.materialQualitySelection.testCertificateLabel = 'Upload MTR (Mill Test Report)';
literals.materialQualitySelection.testCertificateLabelOptional = 'Upload MTR (Mill Test Report) (optional)';
literals.materialTestCert.header = 'MTR (Mill Test Report)';
literals.materialTestCert.testCertToFollow = 'MTR (Mill Test Report) to follow';
literals.materialTestCert.requestCertificate = 'Request MTR (Mill Test Report)';
literals.materialTestCert.requestCertificateSuccess =
    'Your MTR (Mill Test Report) request has been sent to seller successfully.';
literals.materialTestCert.requestCertificateError = 'Your MTR (Mill Test Report) request could not be sent.';
literals.permissionInformation.manager.creditLineInformation = 'See the organizations credit line information';
literals.permissionInformation.manager.editOrganisation = 'Edit the organization information';

export default literals;
